<template>
  <div class="aside-attr" @click.stop>
    <div class="aside-attr-title">画布</div>
    <div class="aside-attr-body base-panel">
      <section>
        <div class="section-title">画布尺寸</div>
        <div class="top-12 ">
          <el-input
            :disabled="true"
            class="size-width"
            v-model="currentItem.json.width"
          >
            <span slot="suffix" class="size-icon">宽</span>
          </el-input>
          <el-input
            class="size-height"
            v-model="height"
            @change="onChange"
            :disabled="isPPT"
          >
            <span slot="suffix" class="size-icon">高</span>
          </el-input>
          <i
            v-if="currentItem.json.originData"
            class="el-icon-refresh-right reset-size-icon"
            @click="onResetSize"
            title="还原"
          ></i>
        </div>
      </section>
      <section class="section-last">
        <!--<p> 画布背景</p>-->
        <div>
          <p class="section-title">背景图片</p>
          <div class="current-bg-list">
            <el-upload
              class="bp-upload-btn1"
              v-if="currentBgList.length === 0"
              :disabled="uploading"
              :action="uploadUrl"
              :show-file-list="false"
              :auto-upload="true"
              accept=".png"
              list-type="picture"
              :on-success="onUploadSuccess"
              :before-upload="onBeforeUpload"
            >
              <el-button
                type="text"
                class="size-15"
                :class="{ 'c-disabled': uploading }"
                size="small"
                :loading="uploading"
              >
                <span>上传背景</span>
              </el-button>
            </el-upload>
            <img
              v-for="(item, index) in currentBgList"
              :key="index"
              :src="item.url"
              class="aab-bg-img"
            />
          </div>
          <el-upload
            class="bp-upload-btn2 top-12"
            v-if="currentBgList.length > 0"
            :disabled="uploading"
            :action="uploadUrl"
            :show-file-list="false"
            :auto-upload="true"
            accept=".png"
            list-type="picture"
            :on-success="onUploadSuccess"
            :before-upload="onBeforeUpload"
          >
            <el-button
              class="size-15 c-btn-color"
              round
              :class="{ 'c-disabled': uploading }"
              size="small"
              :loading="uploading"
            >
              <span>替换背景</span>
            </el-button>
          </el-upload>
        </div>
        <div>
          <div class="section-title top-12">背景颜色</div>
          <div class="top-12">
            <el-color-picker
              class="c-bg-color-picker"
              v-model="modelBgColorValue"
              @active-change="setBgColor"
              popper-class="picker-no-button"
            ></el-color-picker>
            <div class="opacity-tools">
              <el-slider
                v-model="modelOpacityValue"
                @change="setBgOpacity"
                input-size="mini"
              ></el-slider>
              <span>{{ modelOpacityValue }}%</span>
            </div>
          </div>
        </div>
      </section>
    </div>
  </div>
</template>
<script>
import { MATERIAL_UPLOAD } from '../../../request/api/fileupload-api'
import { template_type_ppt } from '@/const.js'
import TUtil from '../TUtil'
export default {
  props: {
    currentItem: {
      type: Object
    },
    currentBgList: {
      type: Array
    },
    bgColor: {
      type: String
    },
    bgOpacity: {
      type: Number
    }
  },
  data () {
    return {
      uploadUrl: MATERIAL_UPLOAD,
      modelBgColorValue: '',
      modelOpacityValue: '',
      uploading: false,
      height: 0
    }
  },
  computed: {
    isPPT () {
      let isAdmin = this.$store.getters['app/isSYSAdmin']
      if (template_type_ppt === this.currentItem.type && !isAdmin) {
        // 非系统管理员，ppt模板不能编辑
        return true
      } else {
        return false
      }
    }
  },
  watch: {
    bgColor: {
      handler (value) {
        this.modelBgColorValue = value
      },
      immediate: true
    },
    bgOpacity: {
      handler (value) {
        this.modelOpacityValue = value
      },
      immediate: true
    },
    'currentItem.json.height' (v) {
      this.height = v
    }
  },
  methods: {
    setBgOpacity (value) {
      this.$emit('onBgOpacityChange', value)
    },
    setBgColor (value) {
      this.$emit('onBgColorChange', value)
    },
    onChange (newHeight) {
      this.$emit('addCache')
      let oldH = this.currentItem.json.height
      this.currentItem.json.height = newHeight < 0 ? 0 : newHeight
      this.$nextTick(() => {
        this.$emit('onHeightChange', {
          oldHeight: +oldH,
          newHeight: +newHeight
        })
      })
    },
    onBeforeUpload (file) {
      let result = TUtil.beforeUploadBg(file)
      if (result) {
        this.uploading = true
      } else {
        this.$message.error('请选择png图片')
      }
      return result
    },
    onUploadSuccess (response) {
      let result = TUtil.uploadSuccessBg(response)
      if (result) {
        let { width, height, url } = result
        if (this.currentBgList && this.currentBgList.length > 0) {
          this.currentBgList[0].url = url
        } else {
          let bgObj = {
            width: width,
            height: height,
            bottom: height,
            url: url
          }
          this.currentItem.json.children.push(
            Object.assign({}, TUtil.getEmptyBgData(), bgObj)
          )
        }
        this.$nextTick(() => {
          this.uploading = false
        })
      }
    },
    onResetSize () {
      let curJson = this.currentItem.json
      let obj = curJson.originData
      if (obj) {
        curJson.width = obj.width
        curJson.height = obj.height
      }
    }
  }
}
</script>
<style lang="scss">
@import './base-panel';
</style>
